// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { PurchaseOrder, purchaseOrderSchema } from '@/purchase-order/api/types';
import { z } from 'zod';

/**
 * Schema for validating the response from the resync purchase order API endpoint.
 */
const resyncPurchaseOrderResponseSchema = z.object({
  data: purchaseOrderSchema,
  metadata: responseMetadataSchema,
});

/**
 * Re-fetches a 3PL-bound purchase order from the provider and reprocesses it,
 * regardless of its current status.
 *
 * @param purchaseOrderKey - The key of the purchase order to resync
 * @returns The reprocessed purchase order
 */
export async function resyncPurchaseOrder(
  purchaseOrderKey: string
): Promise<PurchaseOrder> {
  const url = `/v1/purchase-order/${purchaseOrderKey}/resync`;
  const response = await api.post(url, {});

  const { data } = await parseResponse(
    resyncPurchaseOrderResponseSchema,
    response.data,
    {
      schemaName: 'ResyncPurchaseOrder',
      endpoint: url,
    }
  );
  return data;
}
